export enum PageKind {
  SIGNIN,
  INTRODUCTION,
  DOWNLOAD,
}



// WEBPACK FOOTER //
// /Users/mizunoe_jing/Documents/nice_day_current/bitbucket/starbright/src/app/enum/page-kind.ts